import type { AccountOverview } from './api';

const positive = (value: unknown): value is number => typeof value === 'number' && Number.isFinite(value) && value > 0;
const count = (value: unknown): value is number => typeof value === 'number' && Number.isSafeInteger(value) && value >= 0;

/** Account limits, not measured throughput or a count of downloaded credentials. */
export function accountProfilePolicy(account: Pick<AccountOverview, 'membership' | 'devices'>) {
  const member = account.membership;
  const peak = member?.peakMbps;
  const configured = member?.configuredSpeedMbps;
  return {
    level: member ? member.active ? '高级会员' : '普通会员' : null,
    // Exhausted accounts still have a membership cap; requestedSpeedMbps is zero
    // when access is stopped and must not be mistaken for their configured cap.
    peakMbps: positive(peak) ? Math.min(peak, positive(configured) ? configured : peak) : null,
    maxDevices: count(account.devices?.maxDevices) && account.devices.maxDevices > 0 ? account.devices.maxDevices
      : count(member?.maxDevices) && member.maxDevices > 0 ? member.maxDevices : null,
    onlineDevices: count(account.devices?.onlineDevices) ? account.devices.onlineDevices : null,
  };
}
